<template>
  <el-cascader
    v-bind="$attrs"
    v-on="$listeners"
    placeholder="标签"
    :options="tagOptionsTree"
    :props="{
      multiple: true,
      children: 'childrenList',
      value: 'id',
      label: 'text',
      emitPath: false
    }"
    size="small"
    collapse-tags
    :show-all-levels="false"
    @visible-change="tagOptionsChange"
  ></el-cascader>
</template>

<script>
import { getActiveTreeTag } from '@/api/crm';
export default {
  name: 'gj-tag-cascader',
  data() {
    return {
      tagOptionsTree: [],
    };
  },
  created() {
    getActiveTreeTag().then((res) => {
        this.tagOptionsTree = res;
      });
  },
  methods: {
    tagOptionsChange (ev) {
      if(!ev) {
        this.$emit('visitChange', ev)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-cascader-menu {
  .el-cascader-node.in-active-path {
    font-weight: 400;
  }
  .el-cascader-node.is-selectable.in-checked-path {
    font-weight: 400;
  }
  .el-cascader-node.is-active {
    font-weight: 400;
  }
}
</style>


